// TOP(root仮想フォルダ)選択状態の管理
import { ref } from 'vue';

export const useTopFilter = () => {
  const topOnly = ref(false);
  const topFolderLabel = ref('TOP');

  const initTopPreference = (dataSource) => {
    if (!dataSource) {
      topOnly.value = false;
      return;
    }

    topOnly.value = dataSource.getAttribute('data-top-only') === '1';
    topFolderLabel.value =
      dataSource.getAttribute('data-top-label') || topFolderLabel.value;
  };

  // フォルダ選択AJAXのサーバー応答(top)で状態を同期する
  const syncTopOnly = (value) => {
    topOnly.value = Boolean(value);
  };

  return {
    topOnly,
    topFolderLabel,
    initTopPreference,
    syncTopOnly,
  };
};
